import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const PesoInput = forwardRef((props, ref) => (
  <InputTemplate {...props} escala={3} sufixo=" Kg" ref={ref} />
));

export default PesoInput;
